import { render, staticRenderFns } from "./ServicesReservationAddedServicesTable.vue?vue&type=template&id=39604ffb&"
import script from "./ServicesReservationAddedServicesTable.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationAddedServicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports